export const onVisible = handler => () => {
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") handler()
  })
}
